<script setup lang="ts">
defineOptions({ name: 'AppSectionHeading' })

withDefaults(defineProps<{
  title: string
  description?: string
  icon?: string
}>(), {
  icon: 'i-ri:information-line',
})
</script>

<template>
  <div class="section-heading">
    <span class="section-icon" aria-hidden="true">
      <FaIcon :name="icon" />
    </span>
    <div class="section-body">
      <div class="section-title-row">
        <strong>{{ title }}</strong>
        <FaDivider class="section-divider" />
        <div v-if="$slots.action" class="section-action">
          <slot name="action" />
        </div>
      </div>
      <small v-if="description" class="section-description">{{ description }}</small>
    </div>
  </div>
</template>

<style scoped>
.section-heading {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 12px;
}

.section-icon {
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  color: oklch(var(--primary));
  background: oklch(var(--primary) / 10%);
  border-radius: 9px;
}

.section-icon :deep(svg) {
  width: 16px;
  height: 16px;
}

.section-body {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
  text-align: left;
}

.section-title-row {
  display: flex;
  gap: 10px;
  align-items: center;
  min-height: 32px;
}

.section-title-row strong {
  flex: none;
  font-size: 15px;
  line-height: 1.4;
}

.section-divider {
  flex: 1;
  min-width: 24px;
  margin: 0;
}

.section-description {
  display: block;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.4;
  color: oklch(var(--muted-foreground));
}

.section-action {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}
</style>
